module.exports = __webpack_public_path__ + "static/media/1.573306cc.jpg";